import type { Metadata } from "next";
import { StaticPage } from "@/components/static-page";
import { NewsletterSection } from "@/components/newsletter";

export const metadata: Metadata = {
  title: "Cộng đồng Finzone",
  description:
    "Tham gia cộng đồng Finzone qua Telegram, Zalo Group, Facebook và newsletter buổi sáng.",
  alternates: { canonical: "/cong-dong" },
};

const TELEGRAM_URL = process.env.NEXT_PUBLIC_TELEGRAM_URL ?? "https://t.me/finzonenetwork";
const ZALO_URL = process.env.NEXT_PUBLIC_ZALO_URL ?? "https://zalo.me/g/lkjhonloinvrmnm9xdib";
const FACEBOOK_URL = process.env.NEXT_PUBLIC_FACEBOOK_URL ?? "https://www.facebook.com/finzonenetwork";

export default function Page() {
  return (
    <>
      <StaticPage
        title="Cộng đồng Finzone"
        eyebrow="Community"
        description="Bốn kênh chính để theo dõi và trò chuyện với chúng tôi. Mỗi kênh dành cho một nhịp đọc khác nhau."
      >
        <h2>Telegram Channel</h2>
        <p>
          <a href={TELEGRAM_URL} target="_blank" rel="noopener noreferrer">{TELEGRAM_URL.replace("https://", "")}</a>
          {" "}— kênh đẩy tin nóng, cập nhật lệnh giao dịch và biểu đồ. Phù hợp cho trader bán chuyên cần
          tốc độ. Không có spam, không có lệnh trade trả phí.
        </p>

        <h2>Zalo Group</h2>
        <p>
          <a href={ZALO_URL} target="_blank" rel="noopener noreferrer">Tham gia Zalo Group</a>
          {" "}— không gian thảo luận tiếng Việt cho nhà đầu tư cá nhân.
          Mod nhóm là biên tập viên Finzone, mọi thông tin đăng trong nhóm đều có nguồn dẫn rõ ràng.
        </p>

        <h2>Facebook Fanpage</h2>
        <p>
          <a href={FACEBOOK_URL} target="_blank" rel="noopener noreferrer">facebook.com/finzonenetwork</a>
          {" "}— bản tóm tắt mỗi bài đăng, video ngắn cho người mới làm quen với thị trường.
        </p>

        <h2>Newsletter buổi sáng</h2>
        <p>
          Bản tin tóm tắt thị trường tài chính gửi qua email lúc 7 giờ sáng các ngày làm việc.
          Đọc trong 3 phút trước khi vào ngày giao dịch. Đăng ký bên dưới.
        </p>

        <p
          className="text-[12px] mt-8 italic"
          style={{ color: "var(--ink-3)" }}
        >
          Quy tắc cộng đồng: tôn trọng người khác, không chia sẻ dữ liệu cá nhân, không quảng cáo dự án
          crypto/cổ phiếu chưa rõ ràng. Mod sẽ xóa nội dung vi phạm và mute lặp lại.
        </p>
      </StaticPage>

      <div id="newsletter">
        <NewsletterSection />
      </div>
    </>
  );
}
